webpackJsonp([7],{

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe0b099_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("wVwB");
function injectStyle (ssrContext) {
  __webpack_require__("TlF6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe0b099_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "SAZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	// 中文
	zh: [{
			key: '1001',
			value: '服务器繁忙'
		}, {
			key: '1004',
			value: '请求时间过期'
		}, {
			key: '1005',
			value: '数据错误'
		}, {
			key: '1006',
			value: '帐号或密码不正确'
		}, {
			key: '1009',
			value: '请登陆后操作'
		}, {
			key: '1014',
			value: '三小时后再登陆'
		}, {
			key: '1049',
			value: '该账号被禁用'
		}, {
			key: '1035',
			value: '帐号不存在'
		}, {
			key: '1033',
			value: '手机号码或密码不正确'
		}, {
			key: '1051',
			value: '不支持的第三方oauth平台'
		}, {
			key: '1052',
			value: '第三方oauth未认证成功'
		}, 
		// 自定义
		{
			key: '0001',
			value: '请确认验证码'
		},{
			key: '0002',
			value: '请输入6-12位密码'
		},{
			key: '0003',
			value: '请确认账号'
		},{
			key: '0004',
			value: '请输入账号'
		},{
			key: '0005',
			value: '请输入密码'
		},{
			key: '0006',
			value: '密码修改成功'
		},{
			key: '0007',
			value: '验证码限额（每天10次）已用完。'
		}
	],

	// 英语
	en: [{
			key: '服务器繁忙',
			value: 'Server is busy'
		}, {
			key: '请求时间过期',
			value: 'Request timeout'
		}, {
			key: '数据错误',
			value: 'Account or password error,Enter again'
		}, {
			key: '帐号或密码不正确',
			value: 'Account or password error,Enter again'
		}, {
			key: '请登陆后操作',
			value: 'Please sign in first'
		}, {
			key: '三小时后再登陆',
			value: 'Sign in after 3 hours'
		}, {
			key: '该账号被禁用',
			value: 'This account has been disabled'
		}, {
			key: '用户不存在',
			value: 'Account does not exist'
		}, {
			key: '手机号码或密码不正确',
			value: 'Mobile phone number or password incorrect'
		}, {
			key: '不支持的第三方oauth平台',
			value: 'Unsupported third party oauth platform'
		}, {
			key: '第三方oauth未认证成功',
			value: 'Third party oauth authentication failed'
		},
		// 自定义
		{
			key: '请确认验证码',
			value: 'Please check the verify code'
		},{
			key: '请输入6-12位密码',
			value: 'Please enter the password for 6-12 digits'
		},{
			key: '请确认账号',
			value: 'Please check the account'
		},{
			key: '请输入账号',
			value: 'Please enter the account'
		},{
			key: '请输入密码',
			value: 'Please enter the password'
		},{
			key: '密码修改成功',
			value: 'Your password has been modified successfully !'
		},{
			key: '验证码限额（每天10次）已用完',
			value: 'Verification code quota (10 times per day) has run out.'
		}
	],
});


/***/ }),

/***/ "TlF6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_js_public__ = __webpack_require__("nwBL");




var Confirm = function Confirm() {
	return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ro1h"));
};
var Login = function Login() {
	return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Luci"));
};
var Privacy = function Privacy() {
	return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "MkAd"));
};
var Faq = function Faq() {
	return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "jCLq"));
};
var Selcountry = function Selcountry() {
	return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "pyDA"));
};
var ServiceTerm = function ServiceTerm() {
	return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "Evqn"));
};

var pathName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__static_js_public__["a" /* getPathName */])();
console.log("pathName---", pathName);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: [{
		path: pathName + '/',
		name: 'Confirm',
		component: Confirm
	}, {
		path: pathName + '/login',
		name: 'Login',
		component: Login
	}, {
		path: pathName + 'login',
		redirect: pathName + '/login'
	}, {
		path: pathName + '/privacy',
		name: 'Privacy',
		component: Privacy
	}, {
		path: pathName + 'privacy',
		redirect: pathName + '/privacy'
	}, {
		path: pathName + '/serviceTerm',
		name: 'ServiceTerm',
		component: ServiceTerm
	}, {
		path: pathName + 'serviceTerm',
		redirect: pathName + '/serviceTerm'
	}, {
		path: pathName + '/faq',
		name: 'Faq',
		component: Faq
	}, {
		path: pathName + 'faq',
		redirect: pathName + '/faq'
	}, {
		path: pathName + '/selcountry',
		name: 'Selcountry',
		component: Selcountry
	}, {
		path: pathName + 'selcountry',
		redirect: pathName + '/selcountry'
	}, {
		path: '*',
		redirect: pathName + '/'
	}]
}));

/***/ }),

/***/ "nwBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return facebookRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return APPID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dealLan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dealMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return configObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPathName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getURLParams; });
/* unused harmony export getParamStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return configPlatformObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return configUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_msgs__ = __webpack_require__("SAZi");


//var url = 'https://5703eca29bbecf980cb9647ab2f1712doauth.ibroadlink.com/';
//var url = "https://140593719a46aba20ae7a5c43ca73d97oauth.ibroadlink.com/";
//var url = "https://fc1c75057a24a6a2b911e082dbd9f69coauth.ibroadlink.com/";

var url = 'https://' + window.location.host + '/';

var facebookRedirect = url + 'login';

//facebook的app id
var APPID = '1771203789852650';

//关于lid的配置
var configPlatformObj = {
  alexa: {
    us: "fc1c75057a24a6a2b911e082dbd9f69c",
    eu: "7efc94aead1de486871af24f8109496f",
    zh: "140593719a46aba20ae7a5c43ca73d97",
	id: "4f995e5159c48569a56f5a53c41d0a3b"
  },
  google: {
    us: "5703eca29bbecf980cb9647ab2f1712d",
    eu: "50f581a4070d2ebc30f90720f1b9212a",
    zh: "140593719a46aba20ae7a5c43ca73d97",
	id: "9d5aae85908d4f40e518076ace92f83e"
  },
  ifttt: {
    us: "bfae6a674aab43a5a0e98e9febc487b3",
    eu: "d7f25c1b248ebbd964d54159cb0ab17b",
    zh: "bfae6a674aab43a5a0e98e9febc487b3", //临时
	id: "4f995e5159c48569a56f5a53c41d0a3b"
  }
};

/** 
 * 关于client_id和redirect_uri的配置
 * add by yangzhiyan
*/
var configUrl = {
	alexa: {
		us: {
			client_id: "5ea670ed7cc543133fe3f8e9324e8ba2",
			url: "https://pitangui.amazon.com/api/skill/link/M1TJ2VD8XAW3VZ"
		},
	  	eu: {
			client_id: "ea29a2c9060fa0aa87ab2d617cbdd54c",
			url: "https://pitangui.amazon.com/api/skill/link/M1TJ2VD8XAW3VZ"
		},
		id : {
			// client_id: "id",
			url: "https://pitangui.amazon.com/api/skill/link/M1TJ2VD8XAW3VZ"
		}
	},
	google: {
		us: {
			client_id: "80ac184eb7a704bf663f369d3500542e",
			url: "https://oauth-redirect.googleusercontent.com/r/contros-for-usa"
		},
	  	eu: {
			client_id: "84dcecb35b9123a7052e1c012937b023",
			url: "https://oauth-redirect.googleusercontent.com/r/contros-for-usa"
			//url: "https://oauth-redirect.googleusercontent.com/r/contros-for-eu"
		},
		id : {
			// client_id: "id",
			url: "https://oauth-redirect.googleusercontent.com/r/contros-for-usa"
		}
	}
}

//设置默认的语言 默认英语
var basicLan = "en";

//国家对应的语言配置
var configObj = {
	"zh": "zh",
	"en": "en",
	"eu": "eu",
	"de": "de",
	"ru": "ru",
	"fr": "fr",
	"es": "es",
	"ja": "ja",
	"it": "it",
	"pt": "pt",
	"hi": "hi",
	"pl": "pl",
	"da": "da",
	"sv": "sv"
};

//判断是否有参数
var hrefStr = window.location.href;
console.log("hrefstr",hrefStr)
if(hrefStr.indexOf("lang=") >= 0) {
	var index = hrefStr.indexOf("lang=");
	basicLan = hrefStr.substr(index + 5, 2);
	console.log("lang",index);
}

// 处理页面显示语言
var dealLan = function(content, languaue) {
	//只有隐私政策才有的判断
	return content[languaue] || content[basicLan];
}

// 处理消息
var dealMsg = function(data) {
	var msgTxt = dealLan(__WEBPACK_IMPORTED_MODULE_0__config_msgs__["a" /* default */]);
	for (var i = msgTxt.length - 1; i >= 0; i--) {
		if(msgTxt[i].key == data) {

			if(msgTxt[i].text) {
				return {
					value: msgTxt[i].value,
					text: msgTxt[i].text
				}
			} else {
				return msgTxt[i].value;
			}
		}
	}
};

//取得完整的url 这里暂时排除nginx配置，因为有可能url配置的并不是dist层
var getPathName = function() {
	var pathName = window.location.pathname;
	pathName = pathName.replace("/confirm", "");
	pathName = pathName.replace("/login", "");
	pathName = pathName.replace("/privacy", "");
	pathName = pathName.replace("/serviceTerm", "");
	pathName = pathName.replace("/faq", "");
	pathName = pathName.replace("/selcountry", "");
	if(pathName[pathName.length - 1] == "/") {
		pathName = pathName.substr(0, pathName.length - 1);
	}
	return pathName;
};

//获取URL参数
var getURLParams = function(originStr) {
	var searchStr = originStr || window.location.search || "";
	if(!searchStr) {
		return false;
	}
	//数据object
	var paramObj = {};
	//去除？
	searchStr = searchStr.substring(1);

	//根据数据筛选
	var array = searchStr.split("&");
	for (var i = 0; i < array.length; i++) {
		var temp = array[i];
		//这里多了一步，防止有多个 =
		var tempArray = temp.replace("=", "&").split("&");
		for (var j = 0; j < tempArray.length; j++) {
			var keyStr = tempArray[0], valueStr = tempArray[1];
			if("redirect_uri" === keyStr) {
				//判断 redirect_uri的内容有没有被编译
				if(valueStr.indexOf("://") >= 0) {
					valueStr = encodeURIComponent(valueStr);
				} else if(valueStr.indexOf("%3A%2F%2F") >= 0) {
					valueStr = decodeURIComponent(valueStr);
				}
			}
			paramObj[keyStr] = valueStr;
		}
	}
	return paramObj;
};

//判断是否存在参数
var getParamStr = function(str, originStr) {
	//数据object
	var paramObj = getURLParams(originStr) || {};

	return paramObj[str] || false;
};



/***/ }),

/***/ "wVwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_flexible__ = __webpack_require__("zzYx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_js_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_js_public__ = __webpack_require__("nwBL");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {};
	},
	created: function created() {

		/*** add by huangqb: 判断是否Alexa还是Google ***/
		//设置全局变量的信息
		window.platformBL = this.getPlatform();
		//页面路径
		var _pathName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_public__["a" /* getPathName */])();
		//页面参数
		var _params = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__static_js_public__["b" /* getURLParams */])() || {};
		/*** end ***/

		//根据页面的路径判断页面的指向
		var _pravicy = _params["privacy"] || _params["blprivacys"];
		if (!!_pravicy) {
			this.$router.replace({
				path: _pathName + '/privacy',
				query: _params
			});
			return;
		} else if (_params["blservice"]) {
			this.$router.replace({
				path: _pathName + '/serviceTerm',
				query: _params
			});
			return;
		}

		//取得页面的参数，用于进行h5路由设置
		var pageParam = _params["blpage"];
		switch (pageParam) {
			case "login":
				this.$router.push({
					path: _pathName + '/login',
					query: _params
				});
				break;
			case "privacy":
				this.$router.push({
					path: _pathName + '/privacy'
				});
				break;
			case "service":
				this.$router.push({
					path: _pathName + '/serviceTerm'
				});
				break;
			default:
				break;
		}
	},

	methods: {
		/**
   * 获取平台信息
   * @return {[type]} [description]
   */
		getPlatform: function getPlatform() {
			var host = window.location.search;
			for (var keysObj in __WEBPACK_IMPORTED_MODULE_1__static_js_public__["c" /* configUrl */]) {

				for (var keys in __WEBPACK_IMPORTED_MODULE_1__static_js_public__["c" /* configUrl */][keysObj]) {

					if (host && host.indexOf(__WEBPACK_IMPORTED_MODULE_1__static_js_public__["c" /* configUrl */][keysObj][keys].client_id) >= 0) {
						return keysObj;
					}
				}
			}
			//默认的值
			return "alexa";
		}
	}
});

/***/ }),

/***/ "zzYx":
/***/ (function(module, exports) {

;(function(win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});
    
    if (metaEl) {
        console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));    
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));    
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {                
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)){
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem(){
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
            width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    win.addEventListener('resize', function() {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function(e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }
    

    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function(d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    }
    flexible.px2rem = function(d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    }

})(window, window['lib'] || (window['lib'] = {}));

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bfa2c6e33f3071854dd6.js